import React, { forwardRef } from "react";
import ReactDOM from "react-dom";
import style from "@styles/PageFilterDropdownMenuStyle.module.css";

import { useDispatch } from "react-redux";
import { setFilterOptions } from "@feature/card_render/shop/shopCardSlice";

export const SortModal = ({ anchorRef, onOptionSelect }, ref) => {
  const dispatch = useDispatch();
  const option = [
    { showOption: "낮은 가격순", param: "price_ASC " },
    { showOption: "높은 가격순", param: "price_DESC" },
  ];

  // 모달이 버튼 아래에 위치하도록
  const getModalPosition = () => {
    const buttonRect = anchorRef.current.getBoundingClientRect();
    const modalwidth = buttonRect.width
    return {
      top: buttonRect.bottom + window.scrollY,
      left: buttonRect.right + window.scrollX - modalwidth,
      width: modalwidth
    };
  };

  const modalStyle = getModalPosition();

  const onOptionClick = (option) => {
    const dispatchOption = { key: "sortOrder", value: option.param };
    dispatch(setFilterOptions(dispatchOption));
    onOptionSelect(option.showOption);
  };

  // 모달 jsx
  return ReactDOM.createPortal(
    <ul className={style.dropdownMenu} style={modalStyle} ref={ref}>
      {option.map((option, index) => (
        <li
          className={style.option}
          key={index}
          onClick={() => {
            console.log("Clicked option:", option);
            onOptionClick(option);
          }}
        >
          {option.showOption}
        </li>
      ))}
    </ul>,
    document.getElementById("root")
  );
};

export default forwardRef(SortModal);
